import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["user"];
import classList from '../utils/classList';
import Component from '../Component';
export default class Avatar extends Component {
  view(vnode) {
    var _attrs$loading;
    const _ref = vnode.attrs,
      {
        user
      } = _ref,
      attrs = _objectWithoutProperties(_ref, _excluded);
    attrs.className = classList('Avatar', attrs.className);
    (_attrs$loading = attrs.loading) != null ? _attrs$loading : attrs.loading = 'lazy';
    let content = '';

    // If the `title` attribute is set to null or false, we don't want to give the
    // avatar a title. On the other hand, if it hasn't been given at all, we can
    // safely default it to the user's username.
    const hasTitle = attrs.title === 'undefined' || attrs.title;
    if (!hasTitle) delete attrs.title;

    // If a user has been passed, then we will set up an avatar using their
    // uploaded image, or the first letter of their username if they haven't
    // uploaded one.
    if (user) {
      const username = user.displayName() || '?';
      const avatarUrl = user.avatarUrl();
      if (hasTitle) attrs.title = attrs.title || username;

      // Alt text logic:
      // If the `alt` attribute is set to null or false, we don't want to give the
      // avatar an alt description. If it hasn't been provided, we'll default it to
      // the user's display name *when rendering an <img>* so screen readers have context.
      const hasAlt = attrs.alt === 'undefined' || attrs.alt;
      if (!hasAlt) delete attrs.alt;
      if (avatarUrl) {
        var _user$avatarSrcset, _user$avatarSrcset2;
        // Default alt to username unless explicitly overridden.
        if (attrs.alt === undefined) {
          attrs.alt = username;
        }
        const srcset = (_user$avatarSrcset = (_user$avatarSrcset2 = user.avatarSrcset) == null ? void 0 : _user$avatarSrcset2.call(user)) != null ? _user$avatarSrcset : null;
        return m("img", Object.assign({}, attrs, {
          src: avatarUrl,
          srcSet: srcset != null ? srcset : undefined
        }));
      }
      content = username.charAt(0).toUpperCase();
      attrs.style = !window.testing && {
        '--avatar-bg': user.color()
      };
      delete attrs.loading;
      attrs.role = 'img';
      attrs['aria-label'] = username;
    }

    // Note: We intentionally do NOT set `alt` when rendering the fallback <span>,
    // as `alt` is only valid for certain elements (e.g., <img>, <area>, <input type="image">).
    return m("span", attrs, content);
  }
}
flarum.reg.add('core', 'common/components/Avatar', Avatar);